import { ValuationState } from "services/valuationTask/types";

export type Region = "all" | "domestic" | "intl" | "unreported";

export enum ValuationResultKind {
  SCRAPED_TRACK_LIST = "scraped_track_list",
  FULL_CATALOG = "full_catalog",
  CUSTOM_TRACK_LIST = "custom_track_list",
}

export interface ValuationData {
  valuation_id?: string;
  error?: string;
}
export interface RawDataTrack {
  title: string;
  track_id: string;
  lte: number;
  ltm: number;
  ptm: number;
  pptm: number;
  trend: number;
  earns_since: string | number | null;
  iswc: string | null;
  registration_date: string | null;
  release_date: string | null;
}

export interface ValuationResult {
  id: number;
  kind: ValuationResultKind;
  lifetime_amount: string | null;
  ltm: string | null;
  dollar_age: string | null;
  three_years_average: string | null;
  adj_trend: number | null;
  production_music_index: number | null;
  track_count: number;
  raw_data_track_list: RawDataTrack[];
  first_payment_date: string | null;
  top_income_types: Source[];
  top_songs: Source[];
  top_sources: Source[];
  earnings_by_region: [string, EarningByRegion | number][];
  created_at: string;
  updated_at: string;
  error: Record<string, string> | string | null;
  country_count: number | null;
  lte: number | null;
  most_recent_payment: number | null;
  regions: Partial<Record<Region, { lte: number }>> | null;
  statement_count: number | null;
  top_countries: {
    name: string;
    earnings: number;
    ltm: number;
    lte: number;
  }[];
  top_tracks: {
    name: string;
    earnings: number;
  }[];
  tracks_with_earnings_count: number | null;
}

export interface ListingValuation {
  id: number;
  dollar_age: number;
  earnings_by_region: [string, EarningByRegion | number][];
  lifetime_amount: number;
  ltm: number;
  regions: Region[];
  statistics_last_updated: string;
  three_years_average: number;
  top_income_types: Source[];
  top_music_users: Source[];
  top_songs: Source[];
  top_sources: Source[];
  track_list: Track[];
  top_earnings_by_year: TopEarningsByYear | null;
}

export interface Valuation {
  id: number;
  state: ValuationState;
  results: ValuationResult[];
  valuation_task: number;
  asset: number;
  distribution_frequency: number;
  royalty_payor: string | null;
  status_message: string;
  status_progress: number;
  version: number;
  error: string | null;
  chosen_result: number | null;
}
export interface Source {
  name: string;
  earnings: number;
  track_count?: number;
  earning_details?: { name: string; earnings: number }[];
}

export interface EarningByRegion {
  domestic: number;
  intl: number;
  unreported: number;
  all?: number; // Deprecated but may still appear in old valuation results
  total?: number; // Replaces "all" in new valuation results
}

export interface ValuationResultTrackList {
  title: string;
  trackId: string;
}
export interface Track {
  id: string;
  title: string;
  parent_id?: string;
}

export interface ActiveValuation {
  id: number;
  state: ValuationState;
}

export interface TopTrack {
  track_id: string;
  earnings: number;
}

export interface TopEarningsReport {
  year: string;
  [key: string]: string | number;
}

export interface TopEarningsByYear {
  top_songs: TopEarningsReport[] | null;
  top_income_types: TopEarningsReport[] | null;
  top_sources: TopEarningsReport[] | null;
  top_music_users: TopEarningsReport[] | null;
  top_royalty_payors: TopEarningsReport[] | null;
}
